import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch, ApiError } from "../api/client";
import { ME_KEY } from "../api/hooks/useMe";
import type { Me } from "../api/types";

export function useUpdateProfile() {
  const qc = useQueryClient();
  return useMutation<Me, ApiError, { displayName: string }>({
    mutationFn: (input) =>
      apiFetch<Me>("/api/me", { method: "PATCH", body: input }),
    onSuccess: (me) => {
      qc.setQueryData(ME_KEY, me);
      // Display name appears in workspace names — invalidate so sidebar refreshes.
      qc.invalidateQueries({ queryKey: ["workspaces"] });
    },
  });
}
